import type { EditorView } from '@codemirror/view'
import {
  BoldIcon,
  CodeBracketIcon,
  ItalicIcon,
  LinkIcon,
  ListBulletIcon,
  NumberedListIcon,
  PhotoIcon,
  StrikethroughIcon,
  UnderlineIcon
} from '@heroicons/react/24/outline'
import {
  ExclamationCircleIcon,
  LightBulbIcon,
  QueueListIcon,
  SparklesIcon
} from '@heroicons/react/24/solid'
import { MathIcon, SubscriptIcon, SuperscriptIcon } from '../_svg'
import * as Actions from './actions'

export enum BUTTON_GROUP {
  SMALL = 'small',
  EXTENDED = 'extended',
  FULL = 'full'
}

export type ToolbarButton = {
  icon: React.ElementType
  action: () => void
  label: string
  shortcut?: string
  group: BUTTON_GROUP
}

export const getToolbarButtons = (editorView: EditorView | null): ToolbarButton[] => [
  // always visible
  {
    icon: BoldIcon,
    action: () => Actions.wrapContent(editorView, '**', '**'),
    label: 'Pogrubienie',
    shortcut: 'Mod-b',
    group: BUTTON_GROUP.SMALL
  },
  {
    icon: ItalicIcon,
    action: () => Actions.wrapContent(editorView, '*', '*'),
    label: 'Kursywa',
    shortcut: 'Mod-i',
    group: BUTTON_GROUP.SMALL
  },
  {
    icon: UnderlineIcon,
    action: () => Actions.wrapContent(editorView, '<u>', '</u>'),
    label: 'Podkreślenie',
    shortcut: 'Mod-u',
    group: BUTTON_GROUP.SMALL
  },

  // hidden im more button
  {
    icon: StrikethroughIcon,
    action: () => Actions.wrapContent(editorView, '~', '~'),
    label: 'Przekreślenie',
    shortcut: 'Mod-Shift-x',
    group: BUTTON_GROUP.EXTENDED
  },
  {
    icon: ListBulletIcon,
    action: () => Actions.insertBulletList(editorView),
    label: 'Lista nienumerowana',
    group: BUTTON_GROUP.SMALL
  },
  {
    icon: NumberedListIcon,
    action: () => Actions.insertNumberedList(editorView),
    label: 'Lista numerowana',
    group: BUTTON_GROUP.SMALL
  },
  {
    icon: CodeBracketIcon,
    action: () => Actions.wrapContent(editorView, '`', '`'),
    label: 'Kod',
    shortcut: 'Mod-e',
    group: BUTTON_GROUP.EXTENDED
  },
  {
    icon: SuperscriptIcon,
    action: () => Actions.wrapContent(editorView, '<sup>', '</sup>'),
    label: 'Indeks górny',
    shortcut: 'Mod-.',
    group: BUTTON_GROUP.EXTENDED
  },
  {
    icon: SubscriptIcon,
    action: () => Actions.wrapContent(editorView, '<sub>', '</sub>'),
    label: 'Indeks dolny',
    shortcut: 'Mod-,',
    group: BUTTON_GROUP.EXTENDED
  },
  {
    icon: MathIcon,
    action: () => Actions.insertEquation(editorView),
    label: 'Równanie',
    shortcut: 'Mod-Shift-e',
    group: BUTTON_GROUP.EXTENDED
  },
  {
    icon: LinkIcon,
    action: () => Actions.insertLink(editorView),
    label: 'Link',
    shortcut: 'Mod-k',
    group: BUTTON_GROUP.EXTENDED
  },
  {
    icon: PhotoIcon,
    action: () => Actions.insertImage(editorView),
    label: 'Zdjęcie',
    group: BUTTON_GROUP.EXTENDED
  },

  {
    icon: LightBulbIcon,
    action: () => Actions.insertDeepDiveCard(editorView),
    label: 'Dowiedz się więcej',
    group: BUTTON_GROUP.FULL
  },
  {
    icon: QueueListIcon,
    action: () => Actions.insertContentCard(editorView),
    label: 'Zawartość',
    group: BUTTON_GROUP.FULL
  },
  {
    icon: ExclamationCircleIcon,
    action: () => Actions.insertFocusCard(editorView),
    label: 'Uwaga',
    group: BUTTON_GROUP.FULL
  },

  // TODO: ai content format
  {
    icon: SparklesIcon,
    action: () => {
      return null
    },
    label: 'Formatuj',
    group: BUTTON_GROUP.FULL
  }
]
